import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

class AppGroupService {
    async getAppGroups(environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/AppGroup`;
        if (environmentName) url += `?environmentName=${encodeURIComponent(environmentName)}`;
        let response = await getAuthenticatedFetch()(url);
        return await response.json();
    }

    async getSqlServerVersion(serverId: number, environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/AppGroup/${serverId}/sqlversion`;
        if (environmentName) url += `?environmentName=${encodeURIComponent(environmentName)}`;
        let response = await getAuthenticatedFetch()(url);
        return response.text();
    }

    async getCachedServiceHealthListByAppGroupName(appGrp: string, environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/appGroup/${appGrp}/servicehealth`;
        if (environmentName) url += `?environmentName=${encodeURIComponent(environmentName)}`;
        let response = await getAuthenticatedFetch()(url);
        
        if (!response.ok) {
            throw new Error();
        }
        
        return await response.json();
    }

    async octopusSyncForAll(environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/appGroup/octopusSync`;
        if (environmentName) url += `?environmentName=${encodeURIComponent(environmentName)}`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST'
        });

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }
    
    async octopusSyncForAppGroup(appGrp: string, environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/appGroup/${appGrp}/octopusSync`;
        if (environmentName) url += `?environmentName=${encodeURIComponent(environmentName)}`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST'
        });

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }

    /**
     * An Octopus sync runs in the background, so its progress is polled until it finishes and the
     * counts and actions of the sync are returned.
     */
    async waitForOctopusSync(taskId: string, onProgress: (message: string) => void) {
        let status;
        do {
            await delay(2000);
            status = await this.getOctopusSyncStatus(taskId);
            if (!status.complete) {
                onProgress(status.progressMessage || 'Syncing...');
            }
        } while (!status.complete && !status.errorMessage);

        if (status.errorMessage) {
            throw new Error(status.errorMessage);
        }

        return status.result;
    }

    async getOctopusSyncStatus(taskId: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/appGroup/octopusSyncStatus/${taskId}`;
        let response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }
}

export default new AppGroupService();
